const settings = {
  API_KEY: '6c127b3c75b6f148a4347b27ab4461ee',
  BASE_URL: 'https://api.themoviedb.org/3/',
};

export default settings;
